module.exports = __webpack_public_path__ + "library-variable-template.212d9fb75dfbc6d058510af3c3357246.hashedasset.svg";